// modules & hooks
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Form, Input, Row, Select } from "antd";
import useWindowSize from "../../../hooks/useWindowSize";

const EntityAddress = () => {
  // states
  const isKybSubmitted = useSelector((state) => state.kyb.isKybSubmitted);

  // antd select methods
  const { Option } = Select;
  function handleChange(value) {
    console.log(`selected ${value}`);
  }

  // selectors
  const kybData = useSelector((state) => state.kyb.step2.entityAddress);

  const [formData, setFormData] = useState(kybData);

  useEffect(() => {
    setFormData(kybData);
  }, []);

  console.log({ kybData });

  return (
    <div className="kyb-entity-address">
      <h3 className="container-heading">Entity Address</h3>

      <Col>
        <Form.Item
          style={{ display: "flex", flexDirection: "column" }}
          name="entityAddressCountry"
          label="Entity Address Country"
          rules={
            !isKybSubmitted && !kybData?.entityAddressCountry
              ? [
                  {
                    required: true,
                  },
                ]
              : null
          }>
          <Select
            defaultValue={formData ? formData?.entityAddressCountry : "India"}
            onChange={handleChange}
            disabled={isKybSubmitted}>
            <Option value="India">India</Option>
            <Option value="Egypt">Egypt</Option>
          </Select>
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          name="streetAddress"
          label="Street Address"
          rules={
            !isKybSubmitted && !kybData?.streetAddress
              ? [
                  {
                    required: true,
                    message: "Street Address is required!",
                  },
                  {
                    max: 100,
                    message: "Street Address should be less than 100 symbols!",
                    whitespace: true,
                  },
                ]
              : null
          }>
          <Input
            placeholder="Enter Address"
            value={formData?.streetAddress}
            defaultValue={formData?.streetAddress}
            disabled={isKybSubmitted}
          />
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          name="streetAddress2"
          label="Street Address 2 (Apt, Suite, etc.)"
          rules={
            !isKybSubmitted && !kybData?.streetAddres2
              ? [
                  {
                    required: true,
                    message: "Street Address is required!",
                  },
                  {
                    max: 100,
                    message: "Second Street Address should be less than 100 symbols!",
                    whitespace: true,
                  },
                ]
              : null
          }>
          <Input
            placeholder="Enter Address 2"
            value={formData?.streetAddres2}
            defaultValue={formData?.streetAddres2}
            disabled={isKybSubmitted}
          />
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          name="city"
          label="City"
          rules={
            !isKybSubmitted && kybData?.city
              ? [
                  {
                    required: true,
                    message: "City is required!",
                  },
                  {
                    max: 25,
                    message: "City should be less than 25 symbols!",
                    whitespace: true,
                  },
                ]
              : null
          }>
          <Input
            placeholder="Enter City"
            value={formData?.city}
            defaultValue={formData?.city}
            disabled={isKybSubmitted}
          />
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          name="region"
          label="Region"
          rules={
            !isKybSubmitted && kybData?.region
              ? [
                  {
                    required: true,
                    message: "Region is required!",
                  },
                  {
                    max: 25,
                    message: "Region should be less than 25 symbols!",
                    whitespace: true,
                  },
                ]
              : null
          }>
          <Input
            placeholder="Enter Region"
            value={formData?.region}
            defaultValue={formData?.region}
            disabled={isKybSubmitted}
          />
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          name="postalCode"
          label="Postal Code"
          rules={
            !isKybSubmitted && !kybData?.postalCode
              ? [
                  {
                    required: true,
                    message: "Postal code is required!",
                  },
                  {
                    pattern: /^\d+$/,
                    message: "Postal code is not valid!",
                    whitespace: true,
                  },
                ]
              : null
          }>
          <Input
            placeholder="Enter Postal Code"
            value={formData?.postalCode}
            defaultValue={formData?.postalCode}
            disabled={isKybSubmitted}
          />
        </Form.Item>
      </Col>
    </div>
  );
};

export default EntityAddress;
